import React, { useEffect, useState } from 'react';

import {Col,Button, Row, Input, Form} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faSearch, faList} from '@fortawesome/pro-duotone-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useProduto } from '../../useProduto';
import {atualizaBuscandoProdutos, atualizaListaProdutos, atualizaFiltro} from '../store/gerenciaProdutoReducer'


const FiltroProdutos= (props) => {

    // const [icone, setIcone] = useState(faList);
    const [form] = Form.useForm();

    const {getApi} = props;

    const {filtro, buscandoProdutos} = useSelector(state=> state.gestaoProdutoReducer);

    const {buscarProdutos} = useProduto(getApi);
    const {termo} = filtro;

    // const [buscaEfetuada, setBuscaEfetuada] = useState(false);



    const dispatch = useDispatch();

    // console.log(form);
    form.setFieldsValue({termo});

   
    const buscarHandleClick = async ()=> {
        const termo = form.getFieldValue("termo");
        const novoFiltro = Object.assign({}, filtro, {
            termo,
            page: 1,
            pageSize: 10
        });
        dispatch(atualizaBuscandoProdutos(true));
        try{
            const dados = await buscarProdutos(novoFiltro);
            dispatch(atualizaListaProdutos(dados));
            dispatch(atualizaFiltro(novoFiltro));
            
        } catch(err){
            console.log(err);
        }
        dispatch(atualizaBuscandoProdutos(false));
    }

    

    return <Form form={form} onFinish={buscarHandleClick}>
        <Row>
            <Col span={24}>
                <Input.Group compact>
                    <Form.Item 
                        name="termo"
                        style={{ width: 'calc(100% - 110px)' }}
                    >

                        <Input 
                            
                            placeholder="Digite um termo de busca" 
                            size='large' 
                            
                            prefix={
                                <span><FontAwesomeIcon icon={faSearch} />&nbsp;</span>
                            }
                            // suffix={
                                // <Button type="text" icon={<FontAwesomeIcon icon={icone} />} />
                            // }
                            />
                    </Form.Item>
                        
                    <Button 
                        icon={<FontAwesomeIcon icon={faSearch} />} 
                        style={{ 
                            width: '110px', 
                            // height: '47px' 
                        }} 
                        onClick={buscarHandleClick}
                        loading={buscandoProdutos}
                        
                        type={"primary"} 
                        size="large"
                    >
                        &nbsp;Buscar
                    </Button>
                
                </Input.Group>
            </Col>
        </Row>
    </Form>
}

export {FiltroProdutos}